import {Injectable} from '@angular/core';
import {Country, CountryService as Api} from '../../generated/sales-terminal-client';
import {retry, delay, Subject} from 'rxjs';
import {TranslateService} from "@ngx-translate/core";

export interface TranslatedCountry extends Country {
  translation?: string;
}

@Injectable()
export class CountryService {
  private _countries: Country[] = [];
  private _translatedCountries: TranslatedCountry[] = [];
  // countries which should be at the top of the list in given order, the rest of it should be sorted in alphabetical order
  private _topCountriesIso: string[] = ['EE', 'LV', 'LT', 'BY'];
  public loaded = new Subject();

  constructor(private _api: Api,
              private _translateService: TranslateService) {
    this.getCountries().subscribe({
      next: (values) => {
        this.countries = values;
        this.translateAndSortCountries();
        this.loaded.next(this.countries);
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  get countries() {
    return this._countries;
  }

  get translatedCountries() {
    return this._translatedCountries;
  }

  set countries(values) {
    this._countries = values;
  }

  public getCountries() {
    return this._api.getCountries().pipe(
      delay(1000),
      retry(2)
    );
  }

  public getCountryTranslationKey(countryCode: string): string {
    return this._translatedCountries?.find(country => country.code === countryCode)?.translationKey || countryCode;
  }

  private translateAndSortCountries() {
    this._translatedCountries = this.countries.map((country) => ({
      ...country,
      translation: this._translateService.instant(country.translationKey)
    }));
    this._translatedCountries.sort((a, b) => a.translation.localeCompare(b.translation));
    let topCountries: { element: TranslatedCountry; index: number; }[] = [];
    this._translatedCountries.forEach((element, index, array) => {
      const countyIsoIndex = this._topCountriesIso.indexOf(element.code);
      if (countyIsoIndex !== -1) {
        topCountries.push({ element: element, index: countyIsoIndex });
        array.splice(index, 1);
      }
    });
    const sortedCountries = topCountries.sort((a, b) => (a.index - b.index));
    this._translatedCountries = sortedCountries.map(i => i.element).concat(this._translatedCountries);
  }
}
